import { motion } from 'motion/react'
import { PlatformMarketingCard, stepLabel } from '../groupPlatformItems'
import { LandingSection } from '../LandingSection'

export function GetStartedSection({ items }: { items: PlatformMarketingCard[] }) {
  return (
    <LandingSection className="bg-background" eyebrow="Onboarding" title="Get started">
      <ol className="grid grid-cols-1 gap-8 md:grid-cols-3">
        {items.map((item, index) => {
          const numberMatch = item.card.title.match(/step\s+(\d+)/i)
          const number = numberMatch ? numberMatch[1] : String(index + 1)

          return (
            <motion.li
              key={item.card.id || item.card.title}
              className="flex gap-4"
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-80px' }}
              transition={{ duration: 0.45, delay: index * 0.03 }}
            >
              <span className="flex size-9 shrink-0 items-center justify-center rounded-full bg-primary/10 text-sm font-semibold text-primary">
                {number}
              </span>
              <div>
                <h3 className="font-semibold text-foreground">{stepLabel(item.card.title)}</h3>
                <p className="mt-2 text-sm leading-relaxed text-muted-foreground">{item.card.subtitle}</p>
              </div>
            </motion.li>
          )
        })}
      </ol>
    </LandingSection>
  )
}
